import { AsyncAutoCompleteFieldProps } from "@ucl/library";

export interface AssigneeAsyncAutoCompleteProps {
  odataUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
}

// TODO: THIS WILL BE REMOVED ONCE TASK IS MOVED OVER TO NEW COMPONENT AsyncODataDropdownField
export const assigneeAsyncAutoCompleteConfig: (
  props: AssigneeAsyncAutoCompleteProps
) => AsyncAutoCompleteFieldProps = ({ odataUrl, getAuthRequestHeader }) => {
  return {
    label: "Assignee",
    odataUrl: odataUrl,
    getAuthRequestHeader: getAuthRequestHeader,
  };
};
